// extracted by mini-css-extract-plugin
export var numpadContainer = "_np-1";
export var phoneButton = "_np-0";